/* eslint-disable no-unused-vars */
import axios from 'axios';
import moment from 'moment';
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/document_categories`;

const state = {
    document_categories: []
};

const getters = {
    allDocumentCategories: state => state.document_categories,
};

const actions = {
    async fetchDocumentCategories({ commit }) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${url}?limit=0`, {
                headers: { 'x-drmms-token': authToken }
            });
            let categories = response.data.map((type) => ({
                ...type,
                classification: type.classification == 1 ? "Incoming" : "Outgoing",
                createdAt: moment(type.createdAt).format('LLL'),
                updatedAt: moment(type.updatedAt).format('LLL'),
            }));
            commit('setDocumentCategories', categories);
        } catch (err) {
            console.log(err);
        }
    },
	async createDocumentCategory({ commit }, body) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.post(url, body, {
                headers: { 'x-drmms-token': authToken }
            });

            let newCategory = Object.assign(response.data, {
                classification: response.data.classification == 1 ? "Incoming" : "Outgoing",
				createdAt: moment(response.data.createdAt).format('LLL'),
				updatedAt: moment(response.data.updatedAt).format('LLL')
			});
            commit('newDocumentCategory', newCategory);
            return true;
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                // else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
    },
	async updateDocumentCategory({ commit }, body) {
		try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
				method: 'put',
				url: `${url}/${body.id}`,
				data: { name: body.name, classification: body.classification },
				headers: { 'x-drmms-token': authToken }
			});

            let updatedCategory = Object.assign(response.data, {
                classification: response.data.classification == 1 ? "Incoming" : "Outgoing",
				createdAt: moment(response.data.createdAt).format('LLL'),
				updatedAt: moment(response.data.updatedAt).format('LLL')
			});
            commit('updatedDocumentCategory', updatedCategory);
            return true;
        } catch (err) {
            console.log(err);
            if (err.response) {
                if (err.response.status == 400) return { error: true, status: 400, message: err.response.data }
                // else if (err.response.status == 500) return { error: true, status: 500, message: 'Internal Server Error' };
            }
        }
	},
    async deleteDocumentCategory({ commit }, ids) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios({
                method: "delete",
                url,
                headers: { "x-drmms-token": authToken },
                data: { ids },
            });
            commit('removeDocumentCategory', ids);
            return response;
        } catch (err) {
			return { error: true, status: err.response.status, message: err.response.data }
        }
    },
};

const mutations = {
    setDocumentCategories: (state, categories) => state.document_categories = categories,
    newDocumentCategory: (state, category) => state.document_categories.push(category),
	updatedDocumentCategory: (state, updateCategory) => {
		const index = state.document_categories.findIndex(category => category.id === updateCategory.id);
        if (index !== -1) {
            let editingItem = state.document_categories[index];
            let editedItem = Object.assign(editingItem, updateCategory);
            state.document_categories.splice(index, 1, editedItem);
        }
	},
    removeDocumentCategory: (state, ids) => {
        for (let i = 0; i< ids.length; i++){
            state.document_categories = state.document_categories.filter(category => category.id !== ids[i])
        }
	}
}

export default {
    state,
    getters,
    actions,
    mutations,
}